export default "__VITE_ASSET__opuqHXFA__"